import colorSharp from "../assets/img/color-sharp.webp";
import { stack } from "../data/content";
import { Tags } from "./Tags";

export const Stack = () => {
  return (
    <section className="skill" id="stack">
      <div className="container">
        <div className="skill-bx">
          <h2>Stack</h2>
          <p>Tecnologias que uso no dia a dia, em produção e em projetos pessoais.</p>
          <div className="stack-groups">
            {stack.map(({ group, items }) => (
              <div className="stack-group" key={group}>
                <h3>{group}</h3>
                <Tags items={items} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" aria-hidden="true" />
    </section>
  )
}
